import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankCriteria, getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";
import _ from "underscore";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state, onlyUnloadListing = false) {
    if (onlyUnloadListing) {
      state.listing.loaded = false;
      state.warnings.loaded = false;
    } else {
      stateMerge(state, getUnloadedState());
    }
  },
  [mutation.STATE_UNLOAD_LISTING](state) {
    state.listing.loaded = false;
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_FILTERS](state, { levyCollectionId }) {
    state.listing.levyCollectionId = levyCollectionId;
  },
  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    state.listing.criteria = getBlankCriteria();
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, records) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = records;
    state.listing.empty = records.length == 0 && !state.listing.criteriaInfo.hasCriteria;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },

  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.loaded = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_STARTED](state, { levyCollectionId, providerId }) {
    state.view.loading = true;
    state.view.levyCollectionId = levyCollectionId;
    state.view.providerId = providerId;
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
    state.view.loaded = false;
  },
  [mutation.VIEW_SUCCEEDED](state, provider) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, provider);
  },

  [mutation.WARNINGS_SET_EXPANDED](state, warningType) {
    state.warnings.expanded = warningType;
  },
  [mutation.WARNINGS_SET_UNEXPANDED](state, warningType) {
    if (state.warnings.expanded == warningType) {
      state.warnings.expanded = null;
    }
  },
  [mutation.WARNINGS_GET_STARTED](state, levyCollectionId) {
    state.warnings.levyCollectionId = levyCollectionId;
    state.warnings.loaded = false;
    state.warnings.loading = true;
  },
  [mutation.WARNINGS_GET_FAILED](state) {
    state.warnings.loading = false;
  },
  [mutation.WARNINGS_GET_SUCCEEDED](state, results) {
    state.warnings.loaded = true;
    state.warnings.loading = false;
    state.warnings.data = results;
  },

  [mutation.EXISTS_STARTED](state, { levyCollectionId, providerId }) {
    state.exists.levyCollectionId = levyCollectionId;
    state.exists.providerId = providerId;
    state.exists.loading = true;
  },
  [mutation.EXISTS_FAILED](state) {
    state.exists.loading = false;
    state.exists.loaded = false;
  },
  [mutation.EXISTS_SUCCEEDED](state, exists) {
    state.exists.loading = false;
    state.exists.loaded = true;
    state.exists.exists = exists;
  },

  [mutation.LIST_FOR_PROVIDER_STARTED](state, providerId) {
    state.listingForProvider.providerId = providerId;
    state.listingForProvider.loaded = false;
    state.listingForProvider.loading = true;
  },
  [mutation.LIST_FOR_PROVIDER_FAILED](state) {
    state.listingForProvider.loading = false;
  },
  [mutation.LIST_FOR_PROVIDER_SUCCEEDED](state, results) {
    state.listingForProvider.loaded = true;
    state.listingForProvider.loading = false;
    state.listingForProvider.data = results;
  },

  [mutation.ASSIGNED_PAYMENT_STATUS_INITIALISE](state) {
    state.assignedPaymentStatus.data.assignedPaymentStatus = state.view.data.assignedPaymentStatus;
    state.assignedPaymentStatus.data.latePaymentDays = state.view.data.latePaymentDays;
  },
  [mutation.ASSIGNED_PAYMENT_STATUS_UPDATE](state, details) {
    stateMerge(state.assignedPaymentStatus.data, details);
  },
  [mutation.ASSIGNED_PAYMENT_STATUS_SAVE_STARTED](state) {
    state.assignedPaymentStatus.saving = true;
  },
  [mutation.ASSIGNED_PAYMENT_STATUS_SAVE_SUCCEEDED](state) {
    state.assignedPaymentStatus.saving = false;
  },
  [mutation.ASSIGNED_PAYMENT_STATUS_SAVE_FAILED](state, error) {
    state.assignedPaymentStatus.saving = false;
    state.assignedPaymentStatus.error.details = error;
    state.assignedPaymentStatus.error.show = true;
  },

  [mutation.TASKS_GET_STARTED](state, { levyCollectionId, providerId }) {
    state.tasks.levyCollectionId = levyCollectionId;
    state.tasks.providerId = providerId;
    state.tasks.loading = true;
    state.tasks.loaded = false;
  },
  [mutation.TASKS_GET_FAILED](state) {
    state.tasks.loading = false;
  },
  [mutation.TASKS_GET_SUCCEEDED](state, tasks) {
    state.tasks.loading = false;
    state.tasks.loaded = true;
    state.tasks.data = tasks;
  },

  [mutation.TASK_RUN_STARTED](state, type) {
    state.task.processing = true;
    state.task.type = type;
  },
  [mutation.TASK_RUN_SUCCEEDED](state) {
    state.task.processing = false;
  },
  [mutation.TASK_RUN_FAILED](state, error) {
    state.task.processing = false;
    state.task.error.details = error;
    state.task.error.show = true;
  },

  [mutation.FAVOURITE_QUIETLY_STARTED](state) {
    state.task.processing = true;
  },
  [mutation.FAVOURITE_QUIETLY_FAILED](state) {
    state.task.processing = false;
  },
  [mutation.FAVOURITE_QUIETLY_SUCCEEDED](state, { levyCollectionId, providerId, value }) {
    state.task.processing = false;
    if (state.forTask.loaded) {
      const item = _.find(state.forTask.data, d => {
        return d.levyCollectionId === levyCollectionId && d.providerId === providerId;
      });
      if (item) {
        item.favourite = value;
      }
    }
    if (state.listing.loaded) {
      const item = _.find(state.listing.data, d => {
        return d.levyCollectionId === levyCollectionId && d.providerId === providerId;
      });
      if (item) {
        item.favourite = value;
      }
    }
  },

  [mutation.TASK_RUN_QUIETLY_STARTED](state) {
    state.task.processing = true;
  },
  [mutation.TASK_RUN_QUIETLY_FAILED](state) {
    state.task.processing = false;
  },
  [mutation.TASK_RUN_QUIETLY_SUCCEEDED](state) {
    state.task.processing = false;
  },

  [mutation.UPLOAD_GET_TEMPLATE_STARTED](state) {
    state.view.loading = true;
  },
  [mutation.UPLOAD_GET_TEMPLATE_FAILED](state) {
    state.view.loading = false;
  },
  [mutation.UPLOAD_GET_TEMPLATE_SUCCEEDED](state) {
    state.view.loading = false;
  },

  [mutation.UPLOAD_SPREADSHEET_SET_DRY_RUN](state, isDryRun) {
    state.providerUpload.isDryRun = isDryRun;
  },
  [mutation.UPLOAD_SPREADSHEET_RESET](state, levyCollectionId) {
    state.providerUpload.error.show = false;
    state.providerUpload.processing = false;
    state.providerUpload.isDryRun = true;
    state.providerUpload.validated = false;
    state.providerUpload.levyCollectionId = levyCollectionId;
  },
  [mutation.UPLOAD_SPREADSHEET_STARTED](state) {
    state.providerUpload.processing = true;
    state.providerUpload.error.show = false;
  },
  [mutation.UPLOAD_SPREADSHEET_FAILED](state, error) {
    state.providerUpload.processing = false;
    state.providerUpload.validated = false;
    state.providerUpload.error.show = true;
    state.providerUpload.error.details = error;
  },
  [mutation.UPLOAD_SPREADSHEET_SUCCEEDED](state, results) {
    state.providerUpload.processing = false;
    state.providerUpload.validated = true;
    const processedResults = _.object(
      _(results)
        .pluck("result")
        .map(r => r.toLowerCase()),
      _(results).pluck("count")
    );
    state.providerUpload.data = processedResults;
  },

  [mutation.TASK_GET_PROVIDERS_STARTED](state) {
    state.forTask.loading = true;
    state.forTask.loaded = false;
    state.forTask.data = [];
  },
  [mutation.TASK_GET_PROVIDERS_FAILED](state) {
    state.forTask.loading = false;
    state.forTask.loaded = false;
  },
  [mutation.TASK_GET_PROVIDERS_SUCCEEDED](state, results) {
    state.forTask.loading = false;
    state.forTask.loaded = true;
    state.forTask.data = results;
  },

  [mutation.IN_SCOPE_PREVIEW_GET_STARTED](state, levyCollectionId) {
    state.inScopePreview.loading = true;
    state.inScopePreview.levyCollectionId = levyCollectionId;
  },
  [mutation.IN_SCOPE_PREVIEW_GET_FAILED](state) {
    state.inScopePreview.loading = false;
    state.inScopePreview.loaded = false;
  },
  [mutation.IN_SCOPE_PREVIEW_GET_SUCCEEDED](state, providerIds) {
    state.inScopePreview.loading = false;
    state.inScopePreview.loaded = true;
    state.inScopePreview.data = providerIds;
  },

  [mutation.DISMISS_SAP_RECONCILIATION_WARNING_STARTED](state) {
    state.dismissWarning.processing = true;
  },
  [mutation.DISMISS_SAP_RECONCILIATION_WARNING_FAILED](state) {
    state.dismissWarning.processing = false;
  },
  [mutation.DISMISS_SAP_RECONCILIATION_WARNING_SUCCEEDED](state) {
    state.dismissWarning.processing = false;
  },

  [mutation.GET_STATUS_HISTORY_STARTED](state, { levyCollectionId, providerId }) {
    state.statusHistory.levyCollectionId = levyCollectionId;
    state.statusHistory.providerId = providerId;
    state.statusHistory.loading = true;
  },
  [mutation.GET_STATUS_HISTORY_FAILED](state) {
    state.statusHistory.loading = false;
    state.statusHistory.loaded = false;
  },
  [mutation.GET_STATUS_HISTORY_SUCCEEDED](state, history) {
    state.statusHistory.loading = false;
    state.statusHistory.loaded = true;
    state.statusHistory.data = history;
  },

  [mutation.GET_TIMELINE_STARTED](state, { levyCollectionId, providerId }) {
    state.timeline.levyCollectionId = levyCollectionId;
    state.timeline.providerId = providerId;
    state.timeline.loading = true;
  },
  [mutation.GET_TIMELINE_FAILED](state) {
    state.timeline.loading = false;
    state.timeline.loaded = false;
  },
  [mutation.GET_TIMELINE_SUCCEEDED](state, history) {
    state.timeline.loading = false;
    state.timeline.loaded = true;
    state.timeline.data = history;
  },

  [mutation.FINALISE_GET_STARTED](state) {
    state.finalisation.loading = true;
  },
  [mutation.FINALISE_GET_SUCCEEDED](state, data) {
    state.finalisation.loading = false;
    stateMerge(state.finalisation.data, data);
  },
  [mutation.FINALISE_GET_FAILED](state, error) {
    state.finalisation.loading = false;
    state.finalisation.error.details = error;
    state.finalisation.error.show = true;
  },
  [mutation.FINALISE_SAVE_STARTED](state) {
    state.finalisation.saving = true;
  },
  [mutation.FINALISE_SAVE_SUCCEEDED](state) {
    state.finalisation.saving = false;
  },
  [mutation.FINALISE_SAVE_FAILED](state, error) {
    state.finalisation.saving = false;
    state.finalisation.error.details = error;
    state.finalisation.error.show = true;
  },
  [mutation.FINALISE_UPDATE](state, details) {
    stateMerge(state.finalisation.data, details);
  }
};
